"use strict"
exports.__esModule = true;
exports.MapMarkerIconConfig = {
  name: 'MapMarkerIcon',
  height: 512,
  width: 384,
  svgPath: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z',
  yOffset: 0,
  xOffset: 0,
};
exports.MapMarkerIcon = require('../createIcon').createIcon(exports.MapMarkerIconConfig);
exports["default"] = exports.MapMarkerIcon;